module.exports = __webpack_public_path__ + "media/61.aed21b2d.mp3";